import { ThemeEvents } from '@theme/events';

/**
 * <installment-price>
 *
 * Mantém o valor do parcelamento sincronizado com a variante selecionada.
 *
 * O cálculo continua sendo feito no servidor (Liquid), a partir do preço da
 * variante selecionada. Quando o cliente troca de variante, o tema dispara o
 * evento `variant:update` na seção, carregando o HTML re-renderizado da seção
 * em `event.detail.data.html`. Aqui apenas trocamos o container do valor pelo
 * recém-renderizado — exatamente como o `<product-price>` faz com o preço.
 *
 * Isso evita que o parcelamento fique "congelado" no preço da primeira
 * variante (causa raiz dos valores errados que apareciam de forma intermitente).
 */
class InstallmentPrice extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    if (!this.section) return;
    this.section.addEventListener(ThemeEvents.variantUpdate, this.updateValue);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(ThemeEvents.variantUpdate, this.updateValue);
  }

  /**
   * @param {CustomEvent} event - O evento variant:update.
   */
  updateValue = (event) => {
    const data = event.detail?.data;
    if (!data?.html) return;

    // Combined listings: a variante pode pertencer a outro produto.
    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      // Atualização é de outro produto na mesma seção — ignora.
      return;
    }

    const updated = data.html.querySelector(
      `installment-price[data-block-id="${this.dataset.blockId}"]`
    );
    if (!updated) return;

    const newContainer = updated.querySelector('[ref="parcelaContainer"]');
    const currentContainer = this.querySelector('[ref="parcelaContainer"]');
    if (newContainer && currentContainer) currentContainer.replaceWith(newContainer);
  };
}

if (!customElements.get('installment-price')) {
  customElements.define('installment-price', InstallmentPrice);
}
